import { FormattedMessage } from "react-intl";

const ChangeManagement = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraServiceManagementPricingPageTeam24.features.changeManagement.content.body"
                    defaultMessage="Configure and automate approval workflows based on change type, associated risk, or CAB procedures."
                />
            </p>
        </div>
    );
};

export default ChangeManagement;
